var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _c("div", { staticClass: "flex flex-col" }, [
      _c("div", { staticClass: "flex items-center" }, [
        _vm._m(0),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          staticClass: "supporters-search",
          attrs: {
            type: "text",
            name: "supporter-search",
            placeholder: "Search for supporters"
          },
          domProps: { value: _vm.search },
          on: {
            focus: function($event) {
              return _vm.searchFocus()
            },
            blur: function($event) {
              return _vm.searchBlur($event)
            },
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              },
              _vm.fetchSearchSuggestions
            ],
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k(
                  $event.keyCode,
                  "escape",
                  undefined,
                  $event.key,
                  undefined
                )
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.keyEscape($event)
            }
          }
        })
      ]),
      _c("div", { staticClass: "search-results" }, [
        _vm.isLoading
          ? _c("div", { staticClass: "loading-container" }, [
              _c("img", {
                staticClass: "loading-icon",
                attrs: { src: require("@/assets/img/loading.svg") }
              }),
              _c("div", [_vm._v("Searching...")])
            ])
          : _vm._e(),
        !_vm.isLoading && _vm.displaySuggestions
          ? _c(
              "ul",
              {
                staticClass: "search-results-list",
                on: {
                  mouseleave: function($event) {
                    _vm.selectSuggestion = false
                  },
                  mouseover: function($event) {
                    _vm.selectSuggestion = true
                  }
                }
              },
              [
                _vm._l(_vm.searchResults, function(result) {
                  return _c(
                    "li",
                    {
                      key: result.index,
                      staticClass: "search-result align-middle",
                      on: {
                        click: function($event) {
                          return _vm.giveSupporterDetail(result)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "md:w-1/12" }, [
                        _c("div", { staticClass: "search-result-content" }, [
                          _vm._v(" " + _vm._s(result.id) + " ")
                        ])
                      ]),
                      _c("div", { staticClass: "flex md:w-2/12" }, [
                        _c(
                          "div",
                          {
                            staticClass: "search-result-content supporter-name"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(result.firstName || result.name) +
                                " " +
                                _vm._s(result.lastName) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "flex md:w-3/12" }, [
                        result.display.email
                          ? _c("img", {
                              attrs: { src: require("@/assets/icons/mail.svg") }
                            })
                          : _vm._e(),
                        result.display.email
                          ? _c(
                              "span",
                              { staticClass: "search-result-content" },
                              [_vm._v(_vm._s(result.display.email.contact))]
                            )
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "flex md:w-3/12" }, [
                        result.display.phoneNumber
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/icons/phone.svg")
                              }
                            })
                          : _vm._e(),
                        result.display.phoneNumber
                          ? _c(
                              "span",
                              { staticClass: "search-result-content" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(result.display.phoneNumber.contact) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "flex md:w-3/12" }, [
                        result.display.address &&
                        result.display.address.addressLines
                          ? _c("img", {
                              attrs: { src: require("@/assets/icons/home.svg") }
                            })
                          : _vm._e(),
                        result.display.address
                          ? _c(
                              "span",
                              { staticClass: "search-result-content" },
                              [
                                _vm._v(
                                  _vm._s(result.display.address.addressLines)
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._m(1, true)
                    ]
                  )
                }),
                _vm.searchResults && _vm.searchResultsTotal > 5
                  ? _c(
                      "li",
                      {
                        staticClass: "view-more",
                        on: {
                          click: function($event) {
                            return _vm.viewMoreResults()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "secondary border-none" }, [
                          _vm._v(
                            "View all results (" +
                              _vm._s(_vm.searchResultsTotal) +
                              ")"
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm.noResults
          ? _c("div", { staticClass: "search-no-results" }, [
              _c("div", [_vm._v("No records to display ...")])
            ])
          : _vm._e(),
        _vm.minChars
          ? _c("div", { staticClass: "search-no-results" }, [
              _c("div", [
                _vm._v(
                  "Please type " +
                    _vm._s(_vm.minInputLength) +
                    " or more characters"
                )
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm.displaySuggestions && _vm.displayOverlay
      ? _c("div", {
          staticClass: "search-overlay",
          on: {
            click: function($event) {
              _vm.displaySuggestions = false
            }
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "20px" } }, [
      _c("img", { attrs: { src: require("@/assets/icons/magnifier.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex md:w-1/12" }, [
      _c("img", { attrs: { src: require("@/assets/icons/chevron-right.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }